import React from 'react';
import styled from 'styled-components';
import { Sparkles } from 'lucide-react';

// Spec 2026-10-16 E1 (Karar A) — AI+ olmayan Anketler müşterisinde AI bölümlerinin (genel değerlendirme, tema analizi,
// öneriler + yol haritası) yerinde tek cümlelik değer önerisi. Literal anahtar haritası: statik anahtar testleri dinamik
// dizgiyi göremez.
const AREA_KEYS = {
  assessment: 'survey.report.aiPlus.assessment',
  themes: 'survey.report.aiPlus.themes',
  recommendations: 'survey.report.aiPlus.recommendations',
};

const Card = styled.div`
  display: flex;
  gap: 14px;
  align-items: flex-start;
  margin-bottom: 16px;
  padding: 18px 22px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.report.panel};
  border: 1px dashed ${({ theme }) => theme.colors.report.blueLight};
  color: ${({ theme }) => theme.colors.report.brand};
`;

const Body = styled.div`
  h4 { margin: 0 0 4px; font-size: 14px; font-weight: 800; color: ${({ theme }) => theme.colors.report.brand}; }
  p { margin: 0; font-size: 13px; line-height: 1.5; color: ${({ theme }) => theme.colors.text.muted}; }
`;

const Pill = styled.span`
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  background: ${({ theme }) => theme.colors.report.strongBg};
  color: ${({ theme }) => theme.colors.report.brandDark};
`;

export default function AiPlusCard({ area, t }) {
  return (
    <Card data-testid={`ai-plus-${area}`}>
      <Sparkles size={18} aria-hidden="true" />
      <Body>
        <h4>
          {t(AREA_KEYS[area])}
          <Pill>{t('survey.report.aiPlus.title')}</Pill>
        </h4>
        <p>{t('survey.report.aiPlus.body')}</p>
      </Body>
    </Card>
  );
}
